<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div class="sessions">
    <loading-component>
      <template #content>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          <card-component v-for="(session, index) of sessionsStore.getSessions" v-bind:key="index">
            <template v-slot:body>
              <div class="flex flex-row gap-4 items-center break-all">
                <div class="flex flex-col">
                  <h2 class="card-title">{{ session.user.name }}</h2>

                  <div class="flex flex-col text-gray-400 text-sm">
                    <div>SessionId: {{ session.session_id }}</div>
                    <div>E-Mail: {{ session.user.mail }}</div>
                  </div>
                </div>
              </div>
            </template>

            <template v-slot:footer>
              <!--<button-component fa-icon="fa-regular fa-pencil" />-->
              <!--<delete-component />-->
            </template>
          </card-component>
        </div>
      </template>
    </loading-component>
  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent";
import { mapStores } from "pinia";
import { useSessionsStore } from "@/stores/sessions";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "SessionsView",
  components: { LoadingComponent, CardComponent },
  created() {
    this.sessionsStore.fetchSessions();
  },
  computed: {
    ...mapStores(useSessionsStore)
  }
};
</script>

<style scoped>

</style>